import { Component, h, Host, type JSX, Prop } from "@stencil/core";
import type { Tag } from "@phn/entities/content";
import { isMobile } from "@phn/utility/helper";

export type tagColor = "light" | "dark" | "black";

@Component({
  tag: "phn-model-tags",
  styleUrl: "model-tags.scss",
  scoped: true,
})
export class ModelTags {
  @Prop() breakpoint!: number;

  @Prop() modelTags: Tag[];

  @Prop() tagColor: tagColor = "light";

  // convenience map for better usability
  private pdsColorMap: Map<string, string> = new Map<string, string>([
    ["light", "background-base"],
    ["dark", "background-surface"],
    ["black", "background-surface"],
  ]);

  // TODO implement compact labels if requested
  render(): JSX.Element {
    return (
      <Host role="list">
        {this.modelTags?.map((tag: Tag) => (
          <phn-p-tag
            compact={isMobile(this.breakpoint)}
            role="listitem"
            class="tag"
            theme={this.tagColor === "black" ? "dark" : "light"}
            color={this.pdsColorMap.get(this.tagColor)}
            key={tag.text}
          >
            {tag.text}
          </phn-p-tag>
        ))}
      </Host>
    );
  }
}
